import React from 'react';
import { Button, Icon, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import OptionModal from '../../../../shared/components/OptionModal';
import ModalContentComponent from '../../../../shared/components/ModalContentComponent';
import AlertChangeAdModalComponent from '../../../../shared/components/AlertChangeAdModalComponent';
import CanvaContainer from '../../../../shared/containers/CanvaContainer';
import ResolutionConflictModal from './ResolutionConflictModal';

const LibraryModals = ({
  visibleModalContent,
  visibleModalDeleteContent,
  isModalOpen,
  isModalCreateVersionOpen,
  visibleCanvaModal,
  alertModalVisible,
  conflictModalOpen,
  dynamicAlertVisible,
  closeDynamicAlert,
  contentModal,
  selectTagContent,
  getChangeAdDescription,
  conflictGroups,
  existingByResolution,
  paymentStatus,
  cancelModalContent,
  updateContent,
  showModalDeleteContent,
  replaceVersion,
  handleCancel,
  createVersion,
  handleModalCreateVersionCancel,
  handleChangeAd,
  setAlertModalVisible,
  setVisibleCanvaModal,
  confirmAddAll,
  cancelAddAll
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ModalContentComponent
        visible={visibleModalContent}
        onCancel={cancelModalContent}
        content={contentModal}
      />

      <CanvaContainer
        visible={visibleCanvaModal}
        tag={selectTagContent}
        onClose={() => setVisibleCanvaModal(false)}
      />

      <OptionModal
        title={t('Atention!')}
        body={t(
          'Are you sure you want to delete this ad from the library? You will need to upload it again if you want to use it again.'
        )}
        visible={visibleModalDeleteContent}
        okText={t('Delete')}
        cancelText={t('Cancel')}
        onOk={updateContent}
        onCancel={() => showModalDeleteContent(false)}
        okButtonProps={{ loading: true }}
      />

      <OptionModal
        title={t('Remplace version')}
        body={t('A version with that resolution already exists, you want to replace the content')}
        visible={isModalOpen}
        okText={t('Remplace')}
        cancelText={t('Cancel')}
        onOk={replaceVersion}
        onCancel={handleCancel}
      />

      <OptionModal
        title={t('Create another version')}
        body={t(
          'A version with that resolution already exists on another screen, a new version will be created to avoid replacing the one currently in use.'
        )}
        visible={isModalCreateVersionOpen}
        okText={t('Create')}
        cancelText={t('Cancel')}
        onOk={createVersion}
        onCancel={handleModalCreateVersionCancel}
      />

      <AlertChangeAdModalComponent
        visible={alertModalVisible}
        title={t('Change ad title')}
        description={getChangeAdDescription()}
        onAccept={handleChangeAd}
        onCancel={() => setAlertModalVisible(false)}
        okText={t('Change ad button')}
      />

      {/* Single "Understood" button: adding a dynamic ad already happened, this only
          says where to review it. */}
      <Modal
        title={t('Dynamic Creative Optimization (DCO)')}
        visible={dynamicAlertVisible}
        onCancel={closeDynamicAlert}
        bodyStyle={{ padding: 20 }}
        footer={[
          <Button key="ok" type="primary" onClick={closeDynamicAlert}>
            {t('Understood')}
          </Button>
        ]}
      >
        <p>
          <Icon type="global" />{' '}
          {t('The dynamic ad will be assigned to every screen, review the setup in the next step')}
        </p>
      </Modal>

      <ResolutionConflictModal
        visible={conflictModalOpen}
        conflictGroups={conflictGroups}
        existingByResolution={existingByResolution}
        paymentStatus={paymentStatus}
        onConfirm={confirmAddAll}
        onCancel={cancelAddAll}
      />
    </>
  );
};

export default LibraryModals;
